(function(){
  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  document.addEventListener('DOMContentLoaded', function(){
    var gallery = qs('[data-flyer-gallery]');
    if(!gallery) return;

    var thumbs = qsa('.flyer-thumb', gallery);
    var lightbox = qs('[data-flyer-lightbox]');
    var lightboxImage = qs('[data-flyer-image]', lightbox);
    var currentIndex = 0;

    function openLightbox(index){
      var btn = thumbs[index];
      if(!btn) return;
      var src = btn.getAttribute('data-full') || btn.getAttribute('data-src');
      if(!src) return;
      currentIndex = index;
      lightboxImage.src = src;
      var thumbImg = btn.querySelector('img');
      lightboxImage.alt = (thumbImg && thumbImg.alt) ? thumbImg.alt : (btn.getAttribute('aria-label') || '');
      lightbox.classList.add('is-open');
      lightbox.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox(){
      lightbox.classList.remove('is-open');
      lightbox.classList.add('hidden');
      lightboxImage.src = '';
      document.body.style.overflow = '';
    }

    function next(){ openLightbox((currentIndex + 1) % thumbs.length); }
    function prev(){ openLightbox((currentIndex - 1 + thumbs.length) % thumbs.length); }

    thumbs.forEach(function(btn, i){
      btn.addEventListener('click', function(){ openLightbox(i); });
    });

    var closeBtn = qs('[data-flyer-close]', lightbox);
    if(closeBtn) closeBtn.addEventListener('click', closeLightbox);
    var nextBtn = qs('[data-flyer-next]', lightbox);
    if(nextBtn) nextBtn.addEventListener('click', next);
    var prevBtn = qs('[data-flyer-prev]', lightbox);
    if(prevBtn) prevBtn.addEventListener('click', prev);

    lightbox.addEventListener('click', function(e){ if(e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', function(e){ if(!lightbox.classList.contains('is-open')) return; if(e.key === 'Escape') closeLightbox(); if(e.key === 'ArrowRight') next(); if(e.key === 'ArrowLeft') prev(); });
  });
})();
